import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GmsmenuService {

  private _gmsMenuData: any = {};
  private _menusData: any;
  constructor() { }

  public get gmsMenuData() {
    if (localStorage.getItem('gmsMenuData')) {
      this._gmsMenuData = JSON.parse(localStorage.getItem('gmsMenuData'));
    }
    console.log(' this._gmsMenuData', this._gmsMenuData);
    return this._gmsMenuData;
  }


  clearGmsMenuSession() {
    const gmsMenuLocalData = localStorage.getItem('gmsMenuData');
    if (gmsMenuLocalData) {
      localStorage.removeItem('gmsMenuData');
      localStorage.clear();
      this._gmsMenuData = null;
    }
  }
  public get menusData() {
    return this._menusData;
  }
  public set menusData(reqData) {
    this._menusData = reqData;

  }


  buildGmsMenu(reqMenuData) {
    this.menusData = reqMenuData;
    const menuData = reqMenuData;
    this._gmsMenuData = {};
    menuData.forEach((item) => {
      if (item.level == 0) {
        var menu: any = {};
        var mname = item.name.replace(/\s/g, '').toLowerCase();
        this._gmsMenuData[mname] = item;
        this._gmsMenuData[mname]["submenus"] = [];
      }
    });
    var cnt = 0;
    menuData.forEach((item) => {
      if (item.level == 1) {
        var parObj = this.getLevel0ParentObject(item.parent);
        if (parObj && parObj != null && parObj["submenus"] != null) {
          item["navlinks"] = [];
          item["expand"] = false;
          parObj["submenus"].push(item);
          parObj["submenus"][0]['expand'] = true;
          cnt += 1;
        }


      }
    });
    menuData.forEach((item) => {
      if (item.level == 2) {
        var parObj = this.getLevel1ParentObject(item.parent);
        if (parObj) {
          item["roles"] = [];
          parObj["navlinks"].push(item);
        }
      }
    });
    menuData.forEach((item) => {
      if (item.level == 3) {
        this.getLevel2ParentObject(item.parent, (citem) => {
          citem && citem["roles"].push(item.name);
        });

      }
    });
    console.log(this._gmsMenuData);
    localStorage.setItem("gmsMenuData", JSON.stringify(this._gmsMenuData));
  }
  private getLevel2ParentObject(parentId, callback) {
    for (const key in this._gmsMenuData) {
      if (this._gmsMenuData.hasOwnProperty(key)) {
        if (this._gmsMenuData[key].hasOwnProperty("submenus")) {
          this._gmsMenuData[key]["submenus"].forEach((item) => {
            if (item.hasOwnProperty('navlinks')) {
              const found = item['navlinks'].find(childelement => childelement.id == parentId);
              if (found) {
                callback(found);
              }
            }
          });
          // return childFound && childFound;
        }
      }
    }
    return null;
  }
  private getLevel1ParentObject(parentId) {
    for (const key in this._gmsMenuData) {
      if (this._gmsMenuData.hasOwnProperty(key)) {
        if (this._gmsMenuData[key].hasOwnProperty("submenus")) {
          const found = this._gmsMenuData[key]["submenus"].find(element => element.id == parentId);
          if (found) {
            return found;
          }
        }
      }
    }
    return null;
  }
  private getLevel0ParentObject(parentId) {
    for (const key in this._gmsMenuData) {
      if (this._gmsMenuData.hasOwnProperty(key)) {
        if (this._gmsMenuData[key]["id"] == parentId) {
          return this._gmsMenuData[key];
        }
      }
    }
    return null;
  }
  private defineCustomKeyValue(Obj, key, value) {
    var config = {
      value: value,
      writable: true,
      enumerable: true,
      configurable: true
    };
    Object.defineProperty(Obj, key, config);
    return Obj;
  }
}
